import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useCallback } from 'react';
import { parseDurationToSeconds, secondsToDuration } from '@portfolioiq/shared';
export function DurationInput({ value, onSave, canEdit = true, draftStatus }) {
    const [editing, setEditing] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');
    const inputRef = useRef(null);
    const displayValue = value != null ? secondsToDuration(value) : '-';
    const handleStartEdit = useCallback(() => {
        if (!canEdit)
            return;
        setInputValue(value != null ? secondsToDuration(value) : '');
        setError('');
        setEditing(true);
        setTimeout(() => inputRef.current?.focus(), 0);
    }, [canEdit, value]);
    const handleSave = useCallback(() => {
        const trimmed = inputValue.trim();
        if (!trimmed) {
            setEditing(false);
            return;
        }
        const seconds = parseDurationToSeconds(trimmed);
        if (seconds === null) {
            setError('Invalid format. Use e.g. 2h 30m, 1d, 4h');
            return;
        }
        onSave(seconds.toString());
        setEditing(false);
        setError('');
    }, [inputValue, onSave]);
    const handleCancel = useCallback(() => {
        setEditing(false);
        setError('');
    }, []);
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
        else if (e.key === 'Escape') {
            e.preventDefault();
            handleCancel();
        }
    }, [handleSave, handleCancel]);
    if (editing) {
        return (_jsxs("div", { className: "relative", children: [_jsx("input", { ref: inputRef, type: "text", value: inputValue, onChange: e => { setInputValue(e.target.value); setError(''); }, onKeyDown: handleKeyDown, onBlur: handleSave, placeholder: "e.g. 2h 30m", className: `w-full px-2 py-1 text-sm border rounded focus:outline-none focus:ring-1 ${error ? 'border-red-400 focus:ring-red-400' : 'border-primary-400 focus:ring-primary-400'}` }), error && (_jsx("div", { className: "absolute top-full left-0 mt-1 text-xs text-red-500 bg-white border border-red-200 rounded px-2 py-1 shadow-sm z-10 whitespace-nowrap", children: error }))] }));
    }
    return (_jsxs("span", { onDoubleClick: handleStartEdit, className: `inline-flex items-center gap-1 text-sm ${canEdit ? 'cursor-pointer hover:bg-gray-50 rounded px-1 -mx-1' : ''}`, title: canEdit ? 'Double-click to edit' : undefined, children: [draftStatus && (_jsx("span", { className: `w-1.5 h-1.5 rounded-full flex-shrink-0 ${draftStatus === 'submitted' ? 'bg-amber-400' : 'bg-primary-400'}` })), displayValue] }));
}
//# sourceMappingURL=DurationInput.js.map